// @ts-check
import {Dialog} from '@mui/material';

import Button from '@gaia/components/Button';
import FolderUI from './FolderUI';

/**
 * Modal dialog shows selectable target folders beginning with the root level.
 *
 * @typedef MoveDialogProps
 * @prop {() => void} onClose
 * @prop {boolean} open
 * @prop {(id: string, callback: (objects: Record<string, any>, children: string[]) => void) => void} fetchChildren
 * @prop {(id: string, type: string) => void} onChoose
 * @prop {Record<string, any>} [objects]
 * @prop {string[]} path
 *
 * @param {MoveDialogProps} props
 */
export default function MoveDialog(props) {
    const actions = (
        <Button appearance='secondary' onClick={props.onClose}>
            Cancel
        </Button>
    );

    return (
        <Dialog
            // @ts-ignore
            actions={actions}
            modal={false}
            onRequestClose={props.onClose}
            open={props.open}
            bodyStyle={{padding: 0}}
        >
            <FolderUI
                mode={'choose'}
                objects={props.objects}
                limit={'folder'}
                path={['0']}
                own
                toplevel={'Folders'}
                fetchChildren={props.fetchChildren}
                onChoose={props.onChoose}
            />
        </Dialog>
    );
}
